(function() {
    'use strict';

    angular.module('format')
        .controller('FormatCreateController', FormatCreateController);

    FormatCreateController.$inject = ['$state', 'notificationSrvc', 'formatMessagesConst', 'formatDataSrvc', 'formatGroupDataSrvc', 'errorNotificationSrvc'];

    function FormatCreateController($state, notificationSrvc, formatMessagesConst, formatDataSrvc, formatGroupDataSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            sheet_format: [],
            size_x: [],
            size_y: [],
            format_group: [],
            nonFieldErrors: []
        };

        self.formatData = {
            sheet_format: false,
            size_x: "",
            size_y: "",
            format_group: null,
        };

        self.sizeFields = [{
            prop: 'size_x',
            type: 'number',
            title: 'Rozmiar x',
            isRequired: true,
            isDisabled: false,
            minValue: 0,
            onChange: cleanErrors
        }, {
            prop: 'size_y',
            type: 'number',
            title: 'Rozmiar y',
            isRequired: true,
            isDisabled: false,
            minValue: 0,
            onChange: cleanErrors
        }];

        self.groupsList = [];
        self.groupName = null;

        self.createFormat = createFormat;
        self.cleanErrors = cleanErrors;

        self.redirectTo = redirectTo;

        activate();

        function activate() {
            getGroups();

            if ($state.params.groupPk) {
                self.formatData.format_group = $state.params.groupPk;
                getGroupName($state.params.groupPk);
            }
        }

        function getGroups() {
            return formatGroupDataSrvc.forFormatsList()
                .$promise.then(function(response) {
                    self.groupsList = response;
                    return response;
                });
        }

        function getGroupName(pk) {
            return formatGroupDataSrvc.get({
                pk: pk
            }).$promise.then(function(response) {
                self.groupName = response.name;
                return response;
            });
        }

        function createFormat() {
            formatDataSrvc.create(
                self.formatData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", formatMessagesConst.add);
                    self.redirectTo();
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function redirectTo() {
            if ($state.params.groupPk) {
                $state.go('layout.formatGroup.detail', { pk: $state.params.groupPk });
            } else {
                $state.go('layout.format.list');
            }
        }
    }
})();
